import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
@Component({
  selector: 'app-list-blogs',
  templateUrl: './list-blogs.component.html',
  styleUrls: ['./list-blogs.component.scss']
})

export class ListBlogsComponent {
  @Input() blog : any
  @Input() categoryList : any
    share: any = null;
    currentUrl: any;
    encodeUrl: any;
    baseUrl: any = window.location.origin;
    message: string = '';
    showToast: boolean = false;
    categoryColor: any;
  
  constructor(private router: Router,private toast: ToastrService, private _commonBehaviorChangeService: CommonBehaviorChangeService){
    document.body.addEventListener('click', this.toggleShareBox.bind(this));
  }
  
  /**
     * Hide Share Box on outside click
     * @param event 
     */
  toggleShareBox(event: Event): void {
    const isInsideBlogIcon = (event.target as HTMLElement).closest('.new-share'+this.blog?.id);
    if (!isInsideBlogIcon) {
      this.share = null; // Hides the share box when clicked outside
    }
  }
  
  onLeaveShare(event: MouseEvent): void {
    const shareIconRect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const mouseX = event.clientX;
    const mouseY = event.clientY;
  
    // Check if the mouse is above, below, or to the left of the share icon
    if (mouseX < shareIconRect.left || mouseY < shareIconRect.top || mouseY > shareIconRect.bottom) {
      this.share = 'hide';
    }
  }
  
  
  
  hideShare(event:any){
    const isInsideBlogIcon = (event.target as HTMLElement).closest('.share-icon');
    if (!isInsideBlogIcon) {
      this.share = null; // Hides the share box when clicked outside
    }
  }
  
  
  getBlogThumbnail(imageList: any) {
    if (imageList.length < 1) {
      return 'assets/images/noblogimage.jpg'
    }
    var thumbnail = imageList.filter((img: any) => img.type == 'blog_thumbnail_image')
    if (thumbnail.length > 0) {
      return thumbnail[0].path;
    }
    else {
      return 'assets/images/noblogimage.jpg'
    }
  }
  
  async openBlogDetail(val: any) {
    this.router.navigate(["/individual-blog-updated/"+val.title.split(' ').join('_')+'/'+val.category_id+'/'+val.id])
  }
  
  showShare(hide?: any){
    if(hide == 'hide'){
      this.share = null;
    }
    else{
      if(this.share == hide.id){
        this.share = null;
      }
      else{
        this.share = hide.id;
        this.currentUrl = decodeURI(this.baseUrl + "/individual-blog-updated/" + hide.title.split(' ').join('_') + '/' + hide.category_id + '/' + hide.id)
        this.encodeUrl = encodeURIComponent(this.baseUrl + "/individual-blog-updated/" + hide.title.split(' ').join('_') + '/' + hide.category_id + '/' + hide.id);
      }
    }
  }
  
  clickToCopy(copy: any){
    
    const blogData = this.baseUrl + "/individual-blog-updated/" + copy.title.split(' ').join('_') + '/' + copy.category_id + '/' + copy.id;
  
    // Create a dummy textarea element to perform the copying
    const textarea = document.createElement('textarea');
    textarea.value = blogData;
    document.body.appendChild(textarea);
      
    // Select the text in the textarea
    textarea.select();
    document.execCommand('copy');
      
    // Clean up - remove the textarea
    document.body.removeChild(textarea);
    this._commonBehaviorChangeService.getToast('Blog Link Copied')
  
    this.showShare('hide');
  }
  
  ngOnInit(){
    var category = this.categoryList.find((cat:any) => cat.id == this.blog.category_id);
    if(category && category.color){
      this.categoryColor = category.color;
    }
  }
  
  getCategoryName(blogCatId:any){
    var category = this.categoryList.find((cat:any) => cat.id == blogCatId)
    if(category){
      return category.name;
    }
  }
  }